export enum RequestStatus {
  Approved = 'Approved',
  Denied = 'Denied',
  Pending = 'Pending',
  CancelledByEmployee = 'CancelledByEmployee',
  CancelledByManager = 'CancelledByManager'
}

export enum RequestType {
  LeaveRequest = 'Leave Request',
  ScheduleChange = 'Schedule Change',
  AvailabilityChange = 'Availability Change'
}

export interface RequestRow {
  id: string;
  dateSubmitted: string;
  type: RequestType;
  details?: string;
  status: RequestStatus;
  isPast?: boolean;
}
